import React, { useRef } from 'react';
import RoutePaths from 'src/config/RoutePaths';
import LayoutWrapper from 'src/shared/components/LayoutWrapper';
import styles from './styles.module.scss';
import MetaData from 'src/config/MetaData';
import FaqSection from 'src/components/FaqSection';
import IntroductionSection from './components/IntroductionSection';
import FeaturesSection from './components/FeaturesSection';
import useScrolling from 'src/shared/hooks/useScrolling';
import { fireGA } from 'src/utils/gaUtils';

const pageInfo = MetaData[RoutePaths.HOW_IT_WORKS];

const PlatformFeatures = () => {
    const { scrollToView } = useScrolling();
    const featuresRef = useRef<any>();

    const clickViewFeatures = () => {
        fireGA('marketingQ421', 'clickViewPlatformFeatures');
        scrollToView(featuresRef);
    };

    return (
        <LayoutWrapper
            className={styles.container}
            headerProps={{ type: 'white', className: styles.header, fixed: true }}
            metaProps={{ title: pageInfo.title, description: pageInfo.description, keywords: pageInfo.keywords }}
        >
            <div className={styles.page}>
                <IntroductionSection onClick={clickViewFeatures} />
                <FeaturesSection ref={featuresRef} />
                <FaqSection />
            </div>
        </LayoutWrapper>
    );
};

export default PlatformFeatures;
